import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requirePremium = false }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const hasAICredits =
    (user?.ai_recommendation_credits || 0) > 0 ||
    (user?.ai_analysis_credits || 0) > 0;

  if (requirePremium && !user?.is_premium && !hasAICredits) {
    return <Navigate to="/pricing?upgrade=1" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
